import cx from 'classnames';
import { PhoneInput as InternationalPhoneInput, PhoneInputProps } from 'react-international-phone';
import 'react-international-phone/style.css';

import './index.css';

interface CustomPhoneInputProps extends PhoneInputProps {
  isPublicPage?: boolean;
}

export const PhoneInput = ({
  className,
  isPublicPage = false,
  ...props
}: CustomPhoneInputProps) => {
  return (
    <div>
      <InternationalPhoneInput
        defaultCountry="be"
        preferredCountries={['be', 'fr', 'nl']}
        className={cx('custom-phone-input', isPublicPage ? 'mobile' : '', className)}
        {...props}
      />
    </div>
  );
};
